module.exports = __webpack_public_path__ + "img/loader.2950fe6c.gif";